import React, { Suspense } from 'react';
import Loading from 'components/Loading';

const Attendees = React.lazy(() => import('./Attendees'));

export default function AttendeesCollection(props) {
  return (
    <Suspense fallback={<Loading />}>
      <Attendees {...props} />
    </Suspense>
  );
}
